import { render, staticRenderFns } from "./EditBudgetSubType.vue?vue&type=template&id=d2073b1e&scoped=true"
import script from "./EditBudgetSubType.vue?vue&type=script&lang=js"
export * from "./EditBudgetSubType.vue?vue&type=script&lang=js"
import style0 from "./EditBudgetSubType.vue?vue&type=style&index=0&id=d2073b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2073b1e",
  null
  
)

export default component.exports